import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// ../dashboard/lib/printMixins/index.ts
init_react_import();
import { css } from "styled-components";
var printMixins = {
  hide: css`
    @media print {
      display: none;
    }
  `,
  border: css`
    @media print {
      border: 1px solid ${({ theme }) => theme.color.border.primary};
    }
  `,
  avoidPageBreak: css`
    @media print {
      break-inside: avoid;
    }
  `
};

export {
  printMixins
};
//# sourceMappingURL=chunk-LEFTUPZR.mjs.map